<template>
  <div>
    <v-container v-if="!loadingDialog">
      <!-- Cabeçalho com Título e Filtro (fixo no topo) -->
      <div class="sticky-header">
        <div class="d-flex justify-space-between my-2">
          <h2 class="text-h5 font-weight-medium mb-4">Pedidos</h2>
          <!-- Botão de Filtros para Mobile -->
          <v-btn v-if="isMobile" color="primary" @click="filtrosDialogVisible = true">
            <v-icon left>mdi-filter-variant</v-icon>
            Filtros
          </v-btn>
          <v-btn v-else color="primary" @click="novoPedido">
            <v-icon left>mdi-plus</v-icon>
            Novo Pedido
          </v-btn>

          <v-btn color="primary" class="mx-2" @click="fetchData">
            <v-icon left>mdi-refresh</v-icon>
            Atualizar
          </v-btn>
        </div>
        <v-row>
          <!-- Campo de Busca -->
          <v-col class="mb-2" cols="12" md="4">
            <v-text-field solo v-model="search" label="Buscar" clearable append-icon="mdi-magnify" single-line
              hide-details></v-text-field>
          </v-col>

          <!-- Filtros de Seleção para Desktop -->
          <template v-if="!isMobile">
            <v-col class="mb-2" cols="6" md="3">
              <v-select v-model="filtroPedidoStatus" :items="statusPedidos" label="Status do Pedido" clearable
                outlined></v-select>
            </v-col>
            <v-col class="mb-2" cols="6" md="3">
              <v-select v-model="filtroCliente" :items="clientes" label="Cliente" clearable outlined></v-select>
            </v-col>
            <!-- Botão para Limpar Filtros -->
            <v-col class="mb-2" cols="12" md="2">
              <v-btn small color="primary" @click="limparFiltros">
                <v-icon left>mdi-close-circle-outline</v-icon>
                Limpar
              </v-btn>
            </v-col>
          </template>
        </v-row>
      </div>

      <!-- Tabela (exibida apenas em telas grandes) -->
      <v-data-table v-if="!isMobile" :headers="[
        { title: 'Ações', text: 'Ações', value: 'actions', sortable: false },
        { title: 'ID', text: 'ID', value: 'id_pedido', sortable: true },
        { title: 'Cliente', text: 'Cliente', value: 'cliente.nome', sortable: true },
        { title: 'Status', text: 'Status', value: 'pedido_status', sortable: true },
        { title: 'Data Cadastro', text: 'Data Cadastro', value: 'data_cadastro', sortable: true },
        { title: 'Previsão Entrega', text: 'Previsão Entrega', value: 'previsao_entrega', sortable: true },
      ]" :items="filteredPedidos" :search="search" :options.sync="options" :items-per-page="options.itemsPerPage"
        item-key="id_pedido" class="elevation-1">
        <template v-slot:item.actions="{ item }">
          <!-- Ações para pedidos -->
          <v-btn flat color="primary" @click="openModal(item)">
            <v-icon>mdi-eye</v-icon>
          </v-btn>
          <v-btn class='ml-3' flat color="secondary" @click="editarPedido(item)">
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
        </template>
      </v-data-table>

      <!-- Área de Cards (exibida apenas em telas pequenas) -->
      <div v-if="isMobile" class="cards-container">
        <v-row dense>
          <v-col cols="12" v-for="pedido in filteredPedidos" :key="pedido.id_pedido">
            <v-card class="mb-3" outlined>
              <v-card-title class="d-flex align-center card-title">
                <span class="text-truncate ml-3">
                  Pedido #{{ formatId(pedido.id_pedido) }}
                </span>
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text class="pt-2">
                <div class="info-row">
                  <div class="info-item">
                    <div class="info-title gradient-title">Cliente</div>
                    <div class="info-value">
                      {{ pedido.cliente?.nome || "Não Especificado" }}
                    </div>
                  </div>
                  <div class="info-item">
                    <div class="info-title gradient-title">Status</div>
                    <div class="info-value">
                      {{ pedido.pedido_status || "Não Especificado" }}
                    </div>
                  </div>
                </div>
                <v-divider></v-divider>
                <div class="info-row">
                  <div class="info-item">
                    <div class="info-title gradient-title">Data Cadastro</div>
                    <div class="info-value">
                      {{ formatarData(pedido.data_cadastro) }}
                    </div>
                  </div>
                  <div class="info-item">
                    <div class="info-title gradient-title">Previsão Entrega</div>
                    <div class="info-value">
                      {{ formatarData(pedido.previsao_entrega) }}
                    </div>
                  </div>
                </div>
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions class="d-flex justify-end">
                <v-btn text color="primary" @click="openModal(pedido)">
                  Detalhes
                </v-btn>
                <v-btn text color="secondary" @click="editarPedido(pedido)">
                  Editar
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </div>

      <!-- Área dos Botões -->
      <!-- <div class="buttons-container">
        <v-row justify="center">
          <v-btn color="primary" class="mx-2" @click="fetchData">
            <v-icon left>mdi-refresh</v-icon>
            Atualizar
          </v-btn>
          <v-btn color="secondary" class="mx-2" @click="novoPedido">
            <v-icon left>mdi-plus</v-icon>
            Novo Pedido
          </v-btn>
        </v-row>
      </div> -->
    </v-container>

    <!-- Diálogo de Carregamento -->
    <v-dialog v-model="loadingDialog" persistent max-width="300px">
      <v-card>
        <v-card-text class="text-center">
          <v-progress-circular indeterminate color="primary" class="mb-3"></v-progress-circular>
          <div>Aguarde, {{ mensagemDialog }}</div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Diálogo de Filtros para Mobile -->
    <v-dialog v-model="filtrosDialogVisible" persistent max-width="400px">
      <v-card>
        <v-card-title class="text-h6">Filtros</v-card-title>
        <v-card-text>
          <v-select v-model="filtroPedidoStatus" :items="statusPedidos" label="Status do Pedido" clearable
            outlined></v-select>
          <v-select v-model="filtroCliente" :items="clientes" label="Cliente" clearable outlined></v-select>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="filtrosDialogVisible = false">Aplicar</v-btn>
          <v-btn color="secondary" text @click="limparFiltros">Limpar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Diálogo de Detalhes do Pedido -->
    <v-dialog v-model="detalhesDialogVisible" max-width="1200px" persistent>
      <v-card v-if="pedidoSelecionado">
        <v-card-title class="bg-light-blue-lighten-1 white--text">
          <v-row no-gutters>
            <v-col cols="5" class="d-flex align-center">
              Detalhes do Pedido #{{ pedidoSelecionado.id_pedido }}
            </v-col>
            <v-col cols="4" class="d-flex justify-end align-center">
              <v-chip :color="getStatusColor(pedidoSelecionado.pedido_status)" dark class="px-4"
                style="background-color: black !important;">
                {{ pedidoSelecionado.pedido_status }}
              </v-chip>
            </v-col>
            <v-col cols="3" class="d-flex justify-end align-center">
              <v-btn color="info" flat @click="detalhesDialogVisible = false">Fechar</v-btn>
            </v-col>
          </v-row>
        </v-card-title>

        <v-card-text>
          <v-row>
            <v-col cols="12">

              <!-- Linha alterada: substituindo <v-simple-table> por uma tag <table> nativa -->
              <table class="v-simple-table details-table"> <!-- linha adicionada/alterada -->
                <tbody>
                  <tr>
                    <td class="text-left font-weight-bold pr-4">Cliente</td>
                    <td class="text-right pl-4">{{ pedidoSelecionado.cliente?.nome }}</td>
                  </tr>
                  <tr>
                    <td class="text-left font-weight-bold pr-4">Data de Cadastro</td>
                    <td class="text-right pl-4">{{ formatarData(pedidoSelecionado.data_cadastro) }}</td>
                  </tr>
                  <tr>
                    <td class="text-left font-weight-bold pr-4">Data de Início</td>
                    <td class="text-right pl-4">{{ formatarData(pedidoSelecionado.data_inicio) }}</td>
                  </tr>
                  <tr>
                    <td class="text-left font-weight-bold pr-4">Previsão de Entrega</td>
                    <td class="text-right pl-4">{{ formatarData(pedidoSelecionado.data_previsao) }}</td>
                  </tr>
                  <tr>
                    <td class="text-left font-weight-bold pr-4">Observação</td>
                    <td class="text-right pl-4">{{ pedidoSelecionado.observacao || 'Sem observações' }}</td>
                  </tr>
                </tbody>
              </table>



            </v-col>
          </v-row>
          <!-- modelos dos pedidos -->
          <v-card class="mt-5">
            <v-card-title class="bg-light-blue-lighten-1 white--text d-flex align-center">
              Modelos do Pedido Modelos ({{ calcularTotalModelos(pedidoSelecionado) }}) Peças ({{
                calcularTotalPecas(pedidoSelecionado) }}) </v-card-title>
            <v-card-text>
              <v-container fluid v-if="pedidoSelecionado.pedido_modelos.length">


                <v-data-table :headers="computedHeaders" :items="pedidoSelecionado.pedido_modelos" :items-per-page="5"
                  hide-default-header hide-default-footer class="elevation-1 fixed-width-table" dense>
                  <template #header>
                    <thead>
                      <tr class="header-row">
                        <th class="model-description header-cell">
                          {{ computedHeaders[0].title }}
                        </th>
                        <th v-for="(header, index) in computedHeaders.slice(1)" :key="header.value"
                          class="size-column header-cell">
                          {{ header.title }}
                        </th>
                      </tr>
                    </thead>
                  </template>
                  <template v-slot:bottom>
                  </template>
                  <template #headers>
                    <tr>
                      <th v-for="header in computedHeaders" :key="header.value"
                        class="text-black--bold text-center pa-2"
                        style="background-color: rgb(180 180 180)  !important;">
                        {{ header.title }}
                      </th>
                    </tr>
                  </template>

                  <template #item="{ item }">
                    <tr class="total-row">
                      <td class="total-row">
                        #{{ item.id_pedido_modelo_seq }} - {{ item.modelo?.descricao || 'Sem descrição' }}
                      </td>
                      <td v-for="size in getAllGradeSizes(pedidoSelecionado.pedido_modelos)" :key="size"
                        class="text-right py-2 pr-4 size-column">
                        {{ getModelGradeQuantity(item, size) }}
                      </td>
                    </tr>
                  </template>

                  <template #body.append>
                    <tr class="total-row" style="background-color:rgb(180 180 180)  !important;">
                      <td class="border-right total-label">Total</td>
                      <td v-for="size in getAllGradeSizes(pedidoSelecionado.pedido_modelos)" :key="size"
                        class="text-right total-column">
                        {{ calculateSizeTotal(size) }}
                      </td>
                    </tr>
                  </template>
                </v-data-table>



              </v-container>
              <p v-else class="text-center">Nenhum modelo cadastrado</p>
            </v-card-text>
          </v-card>

          <v-card class="mt-5" v-if="pedidoSelecionado.anexos && pedidoSelecionado.anexos.length">
            <v-card-title class="bg-light-blue-lighten-1 white--text d-flex align-center">
              Documentos do Pedido
            </v-card-title>
            <v-card-text>
              <v-data-table v-if="pedidoSelecionado.anexos && pedidoSelecionado.anexos.length" :headers="[
                { title: 'Arquivo', value: 'descricao' },
                { title: 'Ações', value: 'acoes', sortable: false }
              ]" :items="pedidoSelecionado.anexos" hide-default-footer dense>
                <template v-slot:bottom></template>



                <template v-slot:item.acoes="{ item }">
                  <v-btn small color="primary" @click="previewAnexo(item)" title="Visualizar Arquivo">
                    <v-icon>mdi-eye</v-icon>
                  </v-btn>
                  <v-btn class='ml-3' small color="secondary" @click="downloadAnexo(item)" title="Baixar Arquivo">
                    <v-icon>mdi-download</v-icon>
                  </v-btn>

                </template>
              </v-data-table>
              <p v-else class="text-center">Nenhum documento anexado</p>
            </v-card-text>
          </v-card>

        </v-card-text>

        <!-- <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="detalhesDialogVisible = false">
            Fechar
          </v-btn>
          <v-btn color="secondary" text @click="editarPedido(pedidoSelecionado)">
            Editar
          </v-btn>
        </v-card-actions> -->
      </v-card>
    </v-dialog>

    <!-- Preview Documentos -->
    <v-dialog v-model="previewDialog.show" max-width="100%" max-height="100%">
      <v-card>
        <v-card-title class="bg-light-blue-lighten-1 white--text d-flex align-center">
          {{ previewDialog.documento?.descricao }}
          <v-spacer></v-spacer>
          <v-btn flat @click="previewDialog.show = false">
            Fechar

          </v-btn>
        </v-card-title>
        <v-card-text>
          <div v-if="previewDialog.url" class="pdf-container">
            <iframe :src="previewDialog.url" width="100%" height="900px" frameborder="0"></iframe>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>


  </div>
</template>

<script>
import { pedidoService } from "@/services/pedidoService";
import { useDisplay } from "vuetify";
import { useToast } from "vue-toastification";
const toast = useToast();

export default {
  data() {
    return {
      mensagemDialog: "",
      pedidos: [],
      totalPedidos: 0,
      options: {
        page: 1,
        itemsPerPage: 10,
        sortBy: [],
        sortDesc: [],
      },
      headers: [
        { title: "Ações", text: "Ações", value: "actions", sortable: false },
        { title: "ID", text: "ID", value: "id_pedido", sortable: true },
        { title: "Cliente", text: "Cliente", value: "cliente.nome", sortable: true },
        { title: "Status", text: "Status", value: "pedido_status", sortable: true },
        { title: "Data Cadastro", text: "Data Cadastro", value: "data_cadastro", sortable: true },
        { title: "Previsão Entrega", text: "Previsão Entrega", value: "previsao_entrega", sortable: true },
      ],
      search: "",
      loadingDialog: false,
      filtroPedidoStatus: null,
      filtroCliente: null,
      filtrosDialogVisible: false,
      clientes: [],
      statusPedidos: [
        "Pendente",
        "Em Produção",
        "Concluído",
        "Cancelado"
      ],
      detalhesDialogVisible: false,
      pedidoSelecionado: null,
      previewDialog: {
        show: false,
        documento: null,
        url: null
      }
    };
  },
  computed: {
    isMobile() {
      const { xs } = useDisplay();
      return xs.value;
    },
    filteredPedidos() {
      return this.pedidos.filter((pedido) => {
        const searchTerm = this.search.toLowerCase().trim();

        // Filtro de busca genérico
        const matchSearch =
          !this.search ||
          pedido.id_pedido.toString().includes(searchTerm) ||
          pedido.cliente?.nome.toLowerCase().includes(searchTerm) ||
          pedido.pedido_status.toLowerCase().includes(searchTerm);

        const matchStatus =
          !this.filtroPedidoStatus ||
          pedido.pedido_status === this.filtroPedidoStatus;

        const matchCliente =
          !this.filtroCliente ||
          pedido.cliente?.nome === this.filtroCliente;

        return matchSearch && matchStatus && matchCliente;
      });
    },
    computedHeaders() {
      const sizes = this.getAllGradeSizes(this.pedidoSelecionado.pedido_modelos);
      return [
        { title: 'Modelo', text: 'Modelo', value: 'modelo', sortable: false },
        ...sizes.map(size => ({ title: size, text: size, value: size, sortable: false })),
      ];
    }
  },
  methods: {
    calcularTotalModelos(pedido) {
      return pedido.pedido_modelos.length;
    },



    calcularTotalPecas(pedido) {
      return pedido.pedido_modelos.reduce((total, modelo) => {
        // Sum the quantities from each grade for this modelo
        const modeloTotal = modelo.pedido_modelo_grades.reduce((modeloSum, grade) => {
          return modeloSum + (grade.quantidade || 0);
        }, 0);

        return total + modeloTotal;
      }, 0);
    },
    previewDocument(documento) {
      try {
        // Verifica se o documento é um PDF
        if (!(documento.arquivo.type === 'application/pdf' || documento.arquivo.name.endsWith('.pdf'))) {
          this.$toast.error('Arquivo não é um PDF válido');
          return;
        }

        // Cria URL para preview
        const url = URL.createObjectURL(documento.arquivo);

        // Configura o diálogo de preview
        this.previewDialog = {
          show: true,
          documento: documento,
          url: url
        };
      } catch (error) {
        console.error('Erro ao visualizar documento:', error);
        this.$toast.error('Erro ao visualizar o documento');
      }
    },


    formatId(id) {
      return id ? String(id).padStart(3, "0") : "Não Especificado";
    },
    formatarData(data) {
      return data ? new Date(data).toLocaleDateString('pt-BR') : "Não Especificado";
    },
    async fetchData() {
      this.loadingDialog = true;
      this.mensagemDialog = "Carregando pedidos...";
      try {
        const [pedidosResponse] = await Promise.all([
          pedidoService.obterTodos()
        ]);

        this.pedidos = Array.isArray(pedidosResponse) ? pedidosResponse : [];

        // Extrair clientes únicos
        this.clientes = [...new Set(
          this.pedidos
            .map(pedido => pedido.cliente?.nome)
            .filter(nome => nome) // Remover nomes vazios
        )].sort(); // Opcional: ordenar alfabeticamente
      } catch (error) {
        console.error("Erro ao buscar pedidos:", error);
        toast.error("Erro ao carregar pedidos");
        this.pedidos = [];
      } finally {
        this.loadingDialog = false;
        this.mensagemDialog = "";
      }
    },
    novoPedido() {
      this.$router.push({ name: "CadastroPedidoMobile" });
    },
    editarPedido(pedido) {
      if (!pedido.id_pedido) {
        console.error("Erro: ID do pedido não definido!");
        return;
      }

      this.$router.push({
        name: "AlterarPedidoMobile",
        params: { id: pedido.id_pedido }
      }).catch(err => console.error("Erro na navegação:", err));
    },




    openModal(pedido) {
      this.pedidoSelecionado = pedido;
      this.detalhesDialogVisible = true;
    },
    limparFiltros() {
      this.search = "";
      this.filtroPedidoStatus = null;
      this.filtroCliente = null;
      this.filtrosDialogVisible = false;
    },
    getStatusColor(status) {
      switch (status) {
        case 'Pendente': return 'warning';
        case 'Em Produção': return 'info';
        case 'Concluído': return 'success';
        case 'Cancelado': return 'error';
        default: return 'grey';
      }
    },

    async downloadAnexo(item) {
      try {
        const response = await pedidoService.obterAnexo(item.id_pedido_anexos_seq);
        const blob = new Blob([response.data], { type: 'application/pdf' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = item.nome_arquivo;
        link.click();
      } catch (error) {
        console.error("Erro ao baixar anexo:", error);
        toast.error("Erro ao baixar anexo");
      }
    },
    async previewAnexo(item) {
      try {
        this.loadingDialog = true;
        this.mensagemDialog = "Carregando anexo...";
        const response = await pedidoService.obterAnexo(item.id_pedido_anexos_seq);
        // Verifica se a API retornou uma URL válida
        if (response.data && response.data.url) { // linha adicionada/alterada
          this.previewDialog = {
            show: true,
            documento: item,
            url: response.data.url // linha adicionada/alterada
          };
          return;
        }
        // Caso contrário, tenta criar um blob
        const blob = new Blob([response.data], { type: 'application/pdf' });
        const url = URL.createObjectURL(blob);
        this.previewDialog = {
          show: true,
          documento: item,
          url: url
        };
      } catch (error) {
        console.error("Erro ao visualizar anexo:", error);
        toast.error("Erro ao visualizar anexo");
      }
      finally {
        this.loadingDialog = false;
        this.mensagemDialog = "";
      }
    }
    ,
    getAllGradeSizes(models) {
      const sizes = new Set();
      models.forEach(model => {
        model.pedido_modelo_grades.forEach(grade => {
          sizes.add(grade.tamanho);
        });
      });
      return Array.from(sizes).sort();
    },
    getModelGradeQuantity(model, size) {
      const grade = model.pedido_modelo_grades.find(g => g.tamanho === size);
      return grade ? grade.quantidade : 0;
    },
    calculateSizeTotal(size) {
      const total = this.pedidoSelecionado.pedido_modelos.reduce((acc, model) => {
        const grade = model.pedido_modelo_grades.find(g => g.tamanho === size);
        return acc + (grade ? grade.quantidade : 0);
      }, 0);
      return total;
    }

  },
  created() {
    this.fetchData();
  }
};
</script>

<style scoped>
/* Estilos idênticos aos de máquinas */
.sticky-header {
  position: sticky;
  top: 0;
  z-index: 1;
  background-color: white;
  padding-top: 16px;
  padding-bottom: 16px;
}

.buttons-container {
  padding: 16px;
  margin-top: 16px;
  background-color: white;
}

@media (min-height: 600px) {
  .buttons-container {
    position: sticky;
    bottom: 0;
    z-index: 1;
  }
}

.cards-container {
  max-height: calc(100vh - 200px);
  overflow-y: auto;
}

.card-title {
  font-size: 1rem;
  background: linear-gradient(to right, #2196f3, #2196f3);
  color: white;
  padding: 1px;
}

.v-card-text {
  padding: 0;
}

.gradient-title {
  background: linear-gradient(to right, #f0f0f0, #e0e0e0);
  padding: 5px;
  border-radius: 4px;
  text-align: center;
}

.info-row {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
  font-weight: bold;
}

.info-item {
  flex: 1;
  margin-right: 10px;
  font-weight: bold;
}

.info-value {
  text-align: center;
  padding: 5px;
  border-bottom: 1px solid #ddd;
}

.details-table td {
  padding: 8px;
}

.pdf-container {
  /* Se necessário, defina altura mínima e overflow */
  min-height: 600px;
  overflow: hidden;
}

.fixed-width-table {
  table-layout: fixed;
  width: 100%;
  font-size: 0.875rem;
  /* Consistent font size */
}

.header-row {
  background-color: #616161 !important;
  /* Medium gray */
}

/* Cabeçalho com degradê de cinza */
.header-row th {
  background-color: #616161 !important;
  /* Ensure consistent gray */
  /* degradê de cinza */
  color: white;
  /* texto branco */
  font-weight: bold;
  padding: 8px;
  border: none;
}

/* Primeira coluna (Modelo) */
.model-description {
  width: 200px;
  text-align: left !important;
}

/* Colunas de tamanhos e totais */
.size-column,
.total-column {
  width: 100px;
  text-align: right !important;
}


/* Cabeçalho */
.header-row th {
  background-color: #424242 !important;
  /* Fundo cinza escuro */
  color: white !important;
  /* Texto branco */
  font-weight: bold;
  padding: 8px;
  border: none;
  text-align: right !important;
  /* Alinhamento do texto à direita */
}

/* Cabeçalho da primeira coluna */
.model-description.header-cell {
  width: 200px;
  text-align: right !important;
  /* Alinhamento à direita */
}

/* Cabeçalho das colunas de tamanho */
.size-column.header-cell {
  width: 100px;
  border-top: 1px solid #484343 !important;
  /* Light gray vertical border */
  text-align: right !important;
  /* Alinhamento à direita */
}

/* Linha de totais */
.total-row {
  font-weight: bold;
  background-color: #f5f5f5 !important;
  /* Fundo cinza claro */
}

.total-row td {
  border-right: 1px solid #484343 !important;
  /* Light gray vertical border */
  border-bottom: 1px solid #484343 !important;
  /* Light gray vertical border */
  border-top: 1px solid #484343 !important;
  /* Light gray vertical border */
}


/* Totais alinhados corretamente */
.total-row .total-column {
  width: 100px;
  text-align: right !important;
  border-bottom: 1px solid #484343 !important;
  /* Light gray vertical border */
  border-right: 1px solid #484343 !important;
  /* Light gray vertical border */
  border-top: 1px solid #484343 !important;
  /* Light gray vertical border */
}
</style>
